var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"snap-paper-result master-nav-wrap-container"},[_c('SidebarTableLayout',{scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('main',{attrs:{"data-mfe-id":"npl-body.patsnap"}})]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }